import { client } from "../utils/netlify";
import { deleteCookie, setCookie, getCookie } from "cookies-next";
import { generalConstants } from "@/utils/constants";
import { getUserCauseDetails } from "@/helpers/charityHelper";
import { reportError } from "@/helpers/errorHelper";
import { updateUserCheckoutID } from "@/helpers/userHelpers";
import { setEstimatedShip, setGroupShipDate } from "@/helpers/checkout-shipping/checkoutShippingHelper";
import store from "@/redux/store";
import { updateCart } from "@/redux/actions/addToCartAction";
import { getProductVariant } from "./productHelper";

//fetch client id from cookie for GA4
function get_ga4_clientid() {
  let ga = getCookie('_ga');
  if (!ga) {
    return;
  }
  ga = ga.split('.');
  ga = ga[2] + "." + ga[3];
  return ga;
}

export const addProductToCart = async (request, productDetails = {}, isCharityProduct, mergeCart=false, buyNow=false) => { 
  try {
    let checkoutId, buyNowCheckoutId;
    // checkoutId = getCookie("checkoutId");
    // buyNow condition is added to have a different checkout id for buynow flow
    if (!buyNow) {
      const storage = window.localStorage;
      checkoutId = storage.getItem("pwacheckoutId")
    }
    //If Buy Now is used, do not merge with the existing cart
    if (buyNow) {
      request.createNewCheckout = true; // Ensure a new checkout session is created for Buy Now
    }
    let updateUserCheckoutId = false;

    if (typeof checkoutId !== "undefined" && checkoutId != "") {
      request.id = checkoutId;
    } else {
      // For littledata GA integration
      const clientId = get_ga4_clientid();
      request.clientId = clientId;
      updateUserCheckoutId = true;
    }
    if (!isCharityProduct) {
      // mergeCart prop is added to skip addition of line item attributes again during cart merge process
      // Only cause details are updated in line item attributes
      if(mergeCart) {
        request.lineItemCustomAttributes.push(getCauseLineItemCustomAttr()[0])
      } else {
        request.lineItemCustomAttributes = getCauseLineItemCustomAttr(request.lineItemCustomAttributes);
        if (request.badge_curated) {
          if (request.lineItemCustomAttributes && request.lineItemCustomAttributes.length) {
            request.lineItemCustomAttributes.push({ key: "_badge_curated", value: request.badge_curated });
          } else {
            request.lineItemCustomAttributes = [{ key: "_badge_curated", value: request.badge_curated }];
          }
        }
        if (request.availability) {
          if (request.lineItemCustomAttributes && request.lineItemCustomAttributes.length) {
            request.lineItemCustomAttributes.push({ key: "_availability", value: request.availability });
          } else {
            request.lineItemCustomAttributes = [{ key: "_availability", value: request.availability }];
          }
        } else {
          reportError("Add to cart via cartHelper: Product missing availability tag");
        }
        if (request.oc) {
          if (request.lineItemCustomAttributes && request.lineItemCustomAttributes.length) {
            request.lineItemCustomAttributes.push({ key: "_oc", value: request.oc.value });
          } else {
            request.lineItemCustomAttributes = [{ key: "_oc", value: request.oc.value }];
          }
        }
        if (request.olivela_cost) {
          if (request.lineItemCustomAttributes && request.lineItemCustomAttributes.length) {
            request.lineItemCustomAttributes.push({ key: "_oc", value: request.olivela_cost.value });
          } else {
            request.lineItemCustomAttributes = [{ key: "_oc", value: request.olivela_cost.value }];
          }
        }
        if (request._estimate) {
          if (request.lineItemCustomAttributes && request.lineItemCustomAttributes.length) {
            request.lineItemCustomAttributes.push({ key: "_estimate", value: request._estimate });
          } else {
            request.lineItemCustomAttributes = [{ key: "_estimate", value: request._estimate }];
          }
        }
        if (request.estimate_date) {
          if (request.lineItemCustomAttributes && request.lineItemCustomAttributes.length) {
            request.lineItemCustomAttributes.push(request.estimate_date);
          } else {
            request.lineItemCustomAttributes = [request.estimate_date];
          }
        }

        if (productDetails?.vendor || request.vendor) {
          if (request.lineItemCustomAttributes && request.lineItemCustomAttributes.length) {
            request.lineItemCustomAttributes.push({ key: "_vendor", value: productDetails.vendor? productDetails.vendor : request.vendor });
          } else {
            request.lineItemCustomAttributes = [{ key: "_vendor", value: productDetails.vendor? productDetails.vendor : request.vendor }];
          }
        }

        if (request.barcode) {
          if (request.lineItemCustomAttributes && request.lineItemCustomAttributes.length) {
            request.lineItemCustomAttributes.push({ key: "_upc", value: request.barcode.toString().replace('.00', '') });
          } else {
            request.lineItemCustomAttributes = [{ key: "_upc", value: request.barcode.toString().replace('.00', '') }];
          }
        }

        if (request.correlationId) {
          if (request.lineItemCustomAttributes && request.lineItemCustomAttributes.length) {
            request.lineItemCustomAttributes.push({ key: "_correlationId", value: request.correlationId });
          } else {
            request.lineItemCustomAttributes = [{ key: "_correlationId", value: request.correlationId }];
          }
        }

        if(request?.free_engraving) {
          if (request.lineItemCustomAttributes && request.lineItemCustomAttributes.length) {
            request.lineItemCustomAttributes.push({ key: "Free engraving", value: request.free_engraving });
          } else {
            request.lineItemCustomAttributes = [{ key: "Free engraving", value: request.free_engraving }];
          }
        }
        if(request._engraving_olivela_cost) {
          if (request.lineItemCustomAttributes && request.lineItemCustomAttributes.length) {
            request.lineItemCustomAttributes.push({ key: "_engraving_olivela_cost", value: request._engraving_olivela_cost });
          } else {
            request.lineItemCustomAttributes = [{ key: "_engraving_olivela_cost", value: request._engraving_olivela_cost }];
          }
        }
        if(request._engraving_lead_time) {
          if (request.lineItemCustomAttributes && request.lineItemCustomAttributes.length) {
            request.lineItemCustomAttributes.push({ key: "_engraving_lead_time", value: request._engraving_lead_time });
          } else {
            request.lineItemCustomAttributes = [{ key: "_engraving_lead_time", value: request._engraving_lead_time }];
          }
        }
        if(request.engraving_font) {
          if (request.lineItemCustomAttributes && request.lineItemCustomAttributes.length) {
            request.lineItemCustomAttributes.push({ key: "Engraving font", value: request.engraving_font });
          } else {
            request.lineItemCustomAttributes = [{ key: "Engraving font", value: request.engraving_font }];
          }
        }
        if(request.expectedShip) {
          if (request.lineItemCustomAttributes && request.lineItemCustomAttributes.length) {
            request.lineItemCustomAttributes.push({ key: "_expected-ship", value: request.expectedShip });
          } else {
            request.lineItemCustomAttributes = [{ key: "_expected-ship", value: request.expectedShip }];
          }
        }
        if(request._LPROP) {
          if (request.lineItemCustomAttributes && request.lineItemCustomAttributes.length) {
            request.lineItemCustomAttributes.push({ key: "_LPROP", value: request._LPROP });
          } else {
            request.lineItemCustomAttributes = [{ key: "_LPROP", value: request._LPROP }];
          }
        }
      }
    }
    const resp = await client("add-to-cart", request)
    if(resp){
      let response=resp;
      // setCookie("checkoutId", btoa(response?.id));
        const storage = window.localStorage;
        if(!buyNow){
          storage.setItem("pwacheckoutId", btoa(response?.id));
        }
        if (typeof response.id != "undefined") {
          setCookie("new_cart", true);
        }
        var data = JSON.parse(sessionStorage.getItem("pdp_page_view"))
        var data2 = JSON.parse(sessionStorage.getItem("cart_list"))
        if (productDetails && productDetails.id) {
          data = productDetails;
        }
        response.lines.edges.map((element) => {
          data2?.lines?.edges?.map((item) => {
            if (element.node.title === item.node.title) {
              element.node.parent_id = item.node.parent_id
            }
          })
        })
        response.lines.edges.map((element) => {
          if (element?.node?.title === data?.title) {
            element.node.parent_id = parseInt(data?.handle?.split("-").pop())
          }
        })
        if(!buyNow){
          sessionStorage.setItem("cart_list", JSON.stringify(response));
          setCookie('cookie_present', true)
        }
        // return response;
    }

    /* START: OS-2078 - Retain user cart */
    const isUserLoggedIn = store.getState()?.loginUser?.userLoggedIn;
    if (updateUserCheckoutId && isUserLoggedIn && resp?.id) {
      let cookie_data = JSON.parse(getCookie("userdataToken"));

      //Retain user login state for Buy Now checkout session
      if (buyNow) {
        request.customerAccessToken = cookie_data?.accessToken;
      }

      const resp1 = await updateUserCheckoutID({
        checkout_id: btoa(resp.id),
        customerAccessToken: cookie_data?.accessToken,
      });
    }

    /* END: OS-2078 - Retain user cart */
    return resp;
  } catch (error) {
    reportError('Error in addProductToCart')
    reportError(error)
  }
};

/*
 * @param request - line items ids to be removes
 */
export const removeProductFromCart = async (request) => {
  try{
    let checkoutId;
    // checkoutId = getCookie("checkoutId");
    // if (!checkoutId) {
      const storage = window.localStorage;
      checkoutId = storage.getItem("pwacheckoutId")
    // }
    let response;

    if (checkoutId !== "undefined" && checkoutId != "") {
      request.checkoutId = checkoutId;
      response = await client("remove-from-cart", request)
      if (response && response.id) {
        const storage = window.localStorage;
        setCookie('cookie_present', true)
        sessionStorage.setItem("cart_list", JSON.stringify(response));
        return response;
      } else {
          resetCart(true);
          return null;
        }
    }
    return response;
  }catch(error){
    reportError("Error in removeProductFromCart");
    reportError(error)
  }
};

/*
 * @param request - line items id, variant id and quantity to be updated
 */
export const updateProductInCart = async (request) => {
  try{
    let checkoutId;
    // checkoutId = getCookie("checkoutId");
    // if (!checkoutId) {
      const storage = window.localStorage;
      checkoutId = storage.getItem("pwacheckoutId")
    // }
    if (checkoutId !== "undefined" && checkoutId != "") {
      request.checkoutId = checkoutId;
    }

    const lineItemsWithCustomAttributes = request.lineItems.map((item) => {
      return {
        ...item,
        attributes: getCauseLineItemCustomAttr(item.attributes),
      };
    });

    request.lineItems = lineItemsWithCustomAttributes;

    // SUP-2840 update customer cart only if the checkoutID exists in the cookie
    if(request.checkoutId){
      const response = await client("update-cart", request)
        if (response && response.id) {
          // setCookie("checkoutId", btoa(response?.id));
          const storage = window.localStorage;
          storage.setItem("pwacheckoutId", btoa(response?.id));
          setCookie('cookie_present', true)
          store.dispatch(updateCart(response))
          sessionStorage.setItem("cart_list", JSON.stringify(response));
          store.dispatch(updateCart(response))
          return response;
        } else {
          resetCart(true);
          return null;
        }
    }
    else{
      return
    }
    }catch(error){
      reportError("Error in updateProductInCart");
      reportError(error)
    }
  };

export const getCauseLineItemCustomAttr = (lineItemCustomAttributes) => {
  if (!lineItemCustomAttributes) {
    lineItemCustomAttributes = [];
  }
  else {
    lineItemCustomAttributes = lineItemCustomAttributes.filter(prop => {
      let returnItem = true;
      let propKey = prop.key;
      if (propKey == '_cause' || propKey == '_benefit_unit' || propKey == '_share_percentage' || propKey == '_cost_to_ship') {
        returnItem = false;
      }
      return returnItem
    })
  }
  let userCauseData = getUserCauseDetails();
  let custom_cause_array;
  if (userCauseData && userCauseData.length > 0) {
    userCauseData = userCauseData[0];
    custom_cause_array = [
      { key: "_cause", value: userCauseData.short_code },
      { key: "_benefit_unit", value: userCauseData.benefit_unit },
      { key: "_share_percentage", value: userCauseData.share_percentage },
      { key: "_cost_to_ship", value: generalConstants.cost_to_ship },
    ];
  }
  if (lineItemCustomAttributes.length > 0) {
    lineItemCustomAttributes = lineItemCustomAttributes.concat(custom_cause_array);
  }
  else {
    lineItemCustomAttributes = custom_cause_array;
  }
  return lineItemCustomAttributes;
};

export const resetCart = (ingoreCookie = false) => {
  if (!getCookie("new_cart") || ingoreCookie) {
    const storage = window.localStorage;
    sessionStorage.setItem("cart_list", null);
    // setCookie("checkoutId", null);
    storage.setItem("checkoutId", null);
    setCookie("new_cart", true);
  }
};

//OS-4874 createCart mutation function
export const createCartCheckout = async (cart_list,data,buyerIdentity, isIncognito, isBuyNow) => {
  try{
    // let checkoutId = getCookie("checkoutId");
    let resp;
    let request = {};
    request.cartId = isBuyNow ? null : cart_list.id;
    request.checkoutUrl = cart_list.checkoutUrl;
    request.data = data;
    request.buyerIdentity = buyerIdentity
    request.isIncognito = isIncognito  
    let clientId = get_ga4_clientid();
    /* Get GA4 ID from the cookies and add in the request */
    let ga4session = getCookie(`_ga_${process.env.MEASUREMENT_ID}`);
    if (ga4session) {
      request.ga4session = ga4session;
    }
    // /* Check if we have existing checkoutID in cookie */
    // let existingCheckout = getCookie('new_checkoutId');
    // if (existingCheckout) {
    //   request.existingCheckout = existingCheckout;
    // }

    request.clientId = clientId;
    /* Get GA4 ID from the cookies and add in the request */
    resp = await client("create-cart-checkout", request)
    return resp;
  }catch(error){
    reportError("Error in createCheckout");
    reportError(error)
  }
};

export const createCheckout = async (data,buyerIdentity) => {
  try{
    // let checkoutId = getCookie("checkoutId");
    let resp;
    let request = {};
    request.data = data;
    request.buyerIdentity = buyerIdentity  
    let clientId = get_ga4_clientid();
    /* Get GA4 ID from the cookies and add in the request */
    let ga4session = getCookie(`_ga_${process.env.MEASUREMENT_ID}`);
    if (ga4session) {
      request.ga4session = ga4session;
    }
    /* Check if we have existing checkoutID in cookie */
    let existingCheckout = getCookie('new_checkoutId');
    if (existingCheckout) {
      request.existingCheckout = existingCheckout;
    }

    request.clientId = clientId;
    /* Get GA4 ID from the cookies and add in the request */
    resp = await client("create-checkout", request)
    return resp;
  }catch(error){
    reportError("Error in createCheckout");
    reportError(error)
  }
};

export const getNewCheckoutData = async (checkoutId) => {
  let result = {};
  result.action = 'no-action';
  try {
    if (checkoutId) {
      let request = await client("get-new-checkout-data", { id: checkoutId });
      let response = await request;
      let isCompletedCheckout = response?.completedAt || "";
      if (response?.error || isCompletedCheckout) {
        sessionStorage.setItem("cart_list", null);
        setCookie("cookie_present", "true");
        setCookie("dont_fetch_cart", "true");
        // deleteCookie("checkoutId");
        deleteCookie("new_checkoutId");
        deleteCookie("recommendations_page_seen");
        result.action = 'delete';
        result.email = response?.email;
        return result;
      }
      return result;
    }
  } catch (error) {
    reportError("Error in getNewCheckoutData");
    reportError(error)
  }
}

export const mergeUsersCart = async (checkoutIdSaved) => {
  try{
    let returnResp = [];
    if(checkoutIdSaved) {
      let request = await client("get-checkout-data", { id: checkoutIdSaved }); //Fetch user's saved cart
      let response = await request;
      if (response?.lines?.edges) { //Perfom add to cart for each item
        for (const item of response.lines.edges) {
          if (item?.node && item.node.merchandise?.id && item.node.quantity) {
            let req = {
              variantId: item.node.merchandise.id,
              quantity: item.node.quantity,
              lineItemCustomAttributes: item?.node.attributes ? item?.node.attributes : []
            };
            returnResp = await addProductToCart(req,{},false,true);
          }
        }
      }
    }
    // delete cookie to run the updateCartDates function to update estimated delivery dates of merged items
    deleteCookie("cartSyncDate");
    return returnResp;
  } catch (error) {
    reportError("Error in mergeUsersCart");
    reportError(error)
  }
};

export const updateCheckoutData = async (checkoutId, getCheckoutData) => {
  try{
    let request = await client("get-new-checkout-data", { id: checkoutId });
    var newCheckoutData = await request;
    var cartListData = JSON.parse(sessionStorage.getItem("cart_list"));
    newCheckoutData = newCheckoutData.lineItems.edges;
    cartListData = cartListData?.lines.edges;
    function getDifference(cartListData, newCheckoutData) {
      return cartListData?.filter(object1 => {
        return !newCheckoutData.some(object2 => {
          return object1.node.merchandise.id === object2.node.variant.id;
        });
      });
    }
    if (newCheckoutData?.length != cartListData?.length) {

      setCookie("cart_updated", "true");
      let differenceData = getDifference(cartListData, newCheckoutData);

      let lineItemIds = [];
      if (differenceData && differenceData.length) {

        differenceData.forEach((element) => {
          lineItemIds.push(element.node.id);
        });
        if (lineItemIds && lineItemIds.length) {
          let differenceRequest = {
            lineItemIds: lineItemIds,
          };

          removeProductFromCart(differenceRequest).then(data => {
            let checkoutId;
            // checkoutId = getCookie("checkoutId");
            // if (!checkoutId) {
              checkoutId = localStorage.getItem("pwacheckoutId")
            // }
            getCheckoutData(checkoutId);
          }).catch(e => {
            console.log(e);
          });
        }
      }
    }
    deleteCookie("compareCheckout");
    return 'no-action';
  } catch (error) {
    reportError("Error in updateCheckoutData");
    reportError(error)
  }
}

// Function to update estimated delivery date and expected ship date for items in cart
export async function updateCartDates(cart_list) {
  try {
    // Create a deep copy of cart_list to avoid mutating the original state
    let updatedCartList = JSON.parse(JSON.stringify(cart_list));

    // Loop through each cart line
    for (const line of updatedCartList.lines.edges) {
      try {
        const merchandise = line.node.merchandise;
        const isEngraving = line.node?.attributes?.find(attr => attr?.key === "Free engraving")?.value;
        let updatedEstimatedDeliveryDate;
        let updatedExpectedShipDate;
        //OS-5976 I am fetching here the variant details to check if variant is available for fast shipping or not and also the tags details are fetched here to know the respective Alternativegroup to be considered for the dates
        let fastShippingData = {};

        let variantData = {}
        if(merchandise?.id) {
          variantData = await getProductVariant(merchandise.id);
          if(variantData?.local_item?.value?.toLowerCase() == "local") {
            fastShippingData.fastShippingVariant = true;
            fastShippingData.tags = variantData.product.tags;
          } 
        }

        if(isEngraving && merchandise?.product?.leadShippingTime?.value) {
          // Get the response from setGroupShipDate and setEstimatedShip
          updatedEstimatedDeliveryDate = setGroupShipDate(merchandise, 0, parseInt(merchandise.product.leadShippingTime?.value),fastShippingData);
          updatedExpectedShipDate = setEstimatedShip(merchandise, parseInt(merchandise.product.leadShippingTime?.value))
        } else {
          // Get the response from setGroupShipDate and setEstimatedShip
          updatedEstimatedDeliveryDate = setGroupShipDate(merchandise,0,0,fastShippingData);
          updatedExpectedShipDate = setEstimatedShip(merchandise);
        }
        // Find the _estimate and _expected-ship attribute in the line attributes
        let isEstimatedDeliveryDate = line.node.attributes.find(attr => attr.key === "_estimate");
        let isExpectedShipDate = line.node.attributes.find(attr => attr.key === "_expected-ship");
        let isLocalItem = line.node.attributes.find(attr => attr.key === "_local_item");
        if(updatedEstimatedDeliveryDate?.property) {
          if (isEstimatedDeliveryDate) {
            // Update the _estimate value with the response
            isEstimatedDeliveryDate.value = updatedEstimatedDeliveryDate.property.value;
          } else {
            // If _estimate doesn't exist, add it as a new attribute
            line.node.attributes.push(updatedEstimatedDeliveryDate.property);
          }
        }

        if(updatedExpectedShipDate) {
          if (isExpectedShipDate) {
            // Update the _expected-ship value with the response
            isExpectedShipDate.value = updatedExpectedShipDate.value;
          } else {
            // If _expected-ship doesn't exist, add it as a new attribute
            line.node.attributes.push(updatedExpectedShipDate);
          }
        }

        if (isLocalItem) {
          // Update the _local_item value with the response, here manual check of value was needed as we cant keep the line item empty it has to have some value
          isLocalItem.value = variantData?.local_item?.value ? variantData?.local_item?.value : "null";
        } else {
          // If _local_item doesn't exist, add it as a new attribute
          line.node.attributes.push({
            "key": "_local_item",
            "value": variantData?.local_item?.value ? variantData?.local_item?.value : "null"
          });
        }
      } catch (lineError) {
        reportError(`Error processing line: ${line.node.id}`);
        reportError(lineError);
        return false; // Return false if there's an error processing a line
      }
    }

    // Create a cookie with today's date using cookies-next
    try {
      const now = new Date();
      setCookie('cartSyncDate', now.toISOString().split('T')[0], { maxAge: 24 * 60 * 60 }); // Set cookie for 24 hours
    } catch (cookieError) {
      reportError("Error setting cartSyncDate cookie");
      reportError(cookieError);
      return false; // Return false if there's an error setting the cookie
    }
    sessionStorage.setItem("cart_list", JSON.stringify(updatedCartList));

    const lineItems = await extractLineItems(updatedCartList);

    let req = {};
    req.checkoutId = sessionStorage.getItem("pwacheckoutId")
    req.lineItems = lineItems;

    await updateProductInCart(req)

    return updatedCartList; // Return the updated JSON if everything is successful
  } catch (error) {
    // reportError("Error in updateCartDates");
    reportError(error);
    return false; // Return false if there's a general error
  }
}

export async function extractLineItems(cartJson) {
  const lineItems = cartJson.lines.edges.map(edge => {
    const { id, merchandise, attributes } = edge.node;

    return {
      id: id,
      merchandiseId: merchandise.id,
      attributes: attributes.map(attr => ({
        key: attr.key,
        value: attr.value,
      })),
    };
  });

  return lineItems;
}